import {GOOGLE_MAP_STYLES} from '@constants/google-maps/google-maps.constant';

export class LocationDetailsMapProperties {
  zoom: number;
  center: google.maps.LatLngLiteral;
  mapDisplayType: google.maps.MapTypeId;
  markerOptions: google.maps.MarkerOptions;
  markers: google.maps.LatLngLiteral[];
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    streetViewControl: false,
    fullscreenControl: false,
    panControl: false,
    scrollwheel: false,
    styles: GOOGLE_MAP_STYLES
  };

  constructor() {
    this.zoom = 1;
    this.center = {lat: 0, lng: 0};
    this.mapDisplayType = google.maps.MapTypeId.ROADMAP;
    this.markerOptions = {draggable: false};
    this.markers = [];
  }

  public setCoordinates(lat: number, lng: number, markerLabel: string): void {
    this.zoom = 16;
    this.center = {lat: lat, lng: lng};
    this.mapDisplayType = google.maps.MapTypeId.ROADMAP;
    this.markerOptions = this.generateMarkerOptions(markerLabel);
    this.markers = [];
    this.markers.push({lat: lat, lng: lng});
  }

  private generateMarkerOptions(label: string): google.maps.MarkerOptions {
    if (!label || label.length === 0) {
      label = ' ';
    }

    const pinSVG = 'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,' +
        '11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z';

    const markerImage = {
        path: pinSVG,
        anchor: new google.maps.Point(12,20),
        fillOpacity: 1,
        fillColor: '#222222',
        strokeWeight: 2,
        strokeColor: 'white',
        scale: 2,
        labelOrigin: new google.maps.Point(12,30)
    };

    return {
      draggable: false,
      animation: google.maps.Animation.DROP,
      title: label,
      opacity: 1,
      icon: markerImage,
      label: {
        text: label,
        className: 'google-maps-label',
        color: 'var(--primary)',
        fontSize: '16px',
        fontWeight: 'bold'
      }
    };

  }

}
